import { RootState } from 'models/store';

// ==============================|| PARTY SELECTORS ||============================== //

export const selectEmsPartyDetail = (state: RootState) =>
  state.eai.emsParty.emsPartyDetail;

export const selectEmsPartyList = (state: RootState) =>
  state.eai.emsParty.emsPartyList.partyList;

export const selectEmsPartyListPage = (state: RootState) =>
  state.eai.emsParty.emsPartyList.page;
